import { Component, HostListener, Input } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { database } from 'firebase';

import { Course } from '../../courses/shared/course';
import { CourseLectureService } from '../../courses/shared/course-lecture.service';
import { CourseLectureStatus } from '../../shared/base/course-lecture-status';
import { DialogButtonBase } from '../../shared/base/dialog-button-base';
import { QuestionBase } from '../../shared/dynamic-form/shared/question-base';
import { SelectQuestion } from '../../shared/dynamic-form/shared/question-select';
import { TextAreaQuestion } from '../../shared/dynamic-form/shared/question-textarea';
import { TextboxQuestion } from '../../shared/dynamic-form/shared/question-textbox';
import { MESSAGE_COMMON_ERROR } from '../../shared/message';
import { Lecture } from '../shared/lecture';
import { MESSAGE_ADD_LECTURE_SUCCESS } from '../shared/lecture-message';
import { LectureService } from '../shared/lecture.service';

@Component({
  selector: 'app-lecture-add-button',
  template: '<ng-content></ng-content>'
})
export class LectureAddButtonComponent extends DialogButtonBase {
  @Input() course: Course;

  constructor(dialog: MatDialog, snackBar: MatSnackBar, private service: LectureService, private refService: CourseLectureService) {
    super(dialog, snackBar);
  }

  @HostListener('click') onClick() {
    this.openDialog();
  }

  openDialog(): void {
    super.openDialog(this.title, this.questions);
  }

  async onSubmit(value: Lecture): Promise<any> {
    try {
      const lecture: database.ThenableReference = await this.service.create(value);

      if (this.course) {
        await this.refService.addRef(this.course.$key, lecture.key);
      }

      this.closeDialog();
      this.openSnackBar(MESSAGE_ADD_LECTURE_SUCCESS);
    } catch (e) {
      this.openSnackBar(MESSAGE_COMMON_ERROR);
    }
  }

  private get title(): string {
    return '강의 생성';
  }

  private get questions(): Array<QuestionBase<any>> {
    return [
      new TextboxQuestion({
        key: 'name',
        label: '제목',
        required: true
      }),
      new SelectQuestion({
        key: 'status',
        label: '상태',
        required: true,
      }, CourseLectureStatus.getOptions(CourseLectureStatus.Status.INPROGRESS)),
      new TextAreaQuestion({
        key: 'description',
        label: '간략한 설명'
      })
    ];
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-add-button/lecture-add-button.component.ts